(function(){
  var downX=0,downY=0,downTime=0,downItem=null;
  document.addEventListener("pointerdown",function(e){
    if(downItem=null,!(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)&&!(!e.target||!e.target.closest)&&!e.target.closest(".atipina-qa-bar, .flickity-button, button, input, select, textarea, label, [role=\"button\"], [data-quick-add-btn], [data-sibling-swapper], .swatch__button, .sibling__link, .grid-swatch, tooltip-component, dialog, .drawer, .product-item__swatches")){
      var it=e.target.closest(".product-item");
      it&&(downItem=it,downX=e.clientX,downY=e.clientY,downTime=Date.now())
    }
  },!0);
  document.addEventListener("pointerup",function(e){
    if(downItem){
      var it=downItem;
      if(downItem=null,!(Math.abs(e.clientX-downX)>6||Math.abs(e.clientY-downY)>6)&&!(Date.now()-downTime>700)&&!(!e.target||!e.target.closest||!it.contains(e.target))){
        var link=e.target.closest('a[href*="/products/"]')||it.querySelector('a[href*="/products/"]');
        if(link){
          var href=link.getAttribute("href");
          if(href){
            if(window.__atipinaNavTimer)clearTimeout(window.__atipinaNavTimer);
            window.__atipinaNavTimer=setTimeout(function(){window.__atipinaNavTimer=null;window.location.href=href},150)
          }
        }
      }
    }
  },!0);

  var isTouch=!!(window.matchMedia&&window.matchMedia("(hover: none)").matches);
  var isMouse=!!(window.matchMedia&&window.matchMedia("(hover: hover) and (pointer: fine)").matches)&&window.innerWidth>768;

  function getHandle(item){
    var a=null;
    if(item.matches&&item.matches('a[href*="/products/"]'))a=item;
    else a=item.querySelector('a[href*="/products/"]');
    if(!a)return null;
    var m=(a.getAttribute("href")||"").match(/\/products\/([^\/?#]+)/);
    return m?m[1]:null
  }
  function addAndOpen(variantId){
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:variantId,quantity:1})})
      .then(function(r){return r.ok?r.json():r.json().then(function(err){throw err})})
      .then(function(){
        window.AtipinaToast?(window.AtipinaToast.updateCartUI().catch(function(){}),window.AtipinaToast.showCart&&window.AtipinaToast.showCart()):document.dispatchEvent(new CustomEvent("theme:cart:refresh",{bubbles:!0}))
      })
      .catch(function(err){
        window.AtipinaToast&&window.AtipinaToast.show({error:!0,errorMsg:err&&err.description||err&&err.message||"Tente novamente."})
      })
  }
  function renderSizes(bar,p){
    var optIndex=-1;
    (p.options||[]).forEach(function(o,i){
      var n=(o&&o.name?o.name:o).toString().toLowerCase();
      (n==="tamanho"||n==="size"||n==="talla")&&(optIndex=i)
    });
    if(optIndex<0||!p.variants||!p.variants.length)return!1;
    var byValue={},order=[];
    p.variants.forEach(function(v){
      var val=v.options[optIndex];
      byValue[val]?!byValue[val].available&&v.available&&(byValue[val]={id:v.id,available:!0}):(byValue[val]={id:v.id,available:!!v.available},order.push(val))
    });
    bar.innerHTML="";
    var lbl=document.createElement("span");
    lbl.className="atipina-qa-label";
    lbl.textContent="Escolha o tamanho:";
    bar.appendChild(lbl);
    order.forEach(function(val){
      var info=byValue[val],b=document.createElement("button");
      b.type="button";b.className="atipina-qa-size";b.textContent=val;
      info.available||(b.disabled=!0);
      b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();!b.disabled&&addAndOpen(info.id)});
      bar.appendChild(b)
    });
    if(bar.children.length>1){bar.classList.add("atipina-qa-expanded");return!0}
    return!1
  }
  function buildBar(item){
    if(!item._qaBarInit&&(item._qaBarInit=!0,!(item.closest(".predictive-search")||item.closest("predictive-search")||item.closest(".search-popdown")||item.closest(".pdp-related")||item.closest("[data-pdp-tabbed]")||item.closest("[data-pdp-carousel-track]")))){
      var handle=getHandle(item);
      if(handle){
        var bar=document.createElement("div");
        bar.className="atipina-qa-bar";
        var open=document.createElement("button");
        open.type="button";
        open.className="atipina-qa-open";
        open.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
        open.setAttribute("aria-label","Adicionar rápido");
        open.setAttribute("title","Adicionar rápido");
        open.addEventListener("click",function(e){
          e.preventDefault();e.stopPropagation();
          var native=item.querySelector("[data-quick-add-btn]")||document.querySelector('[data-quick-add-modal-handle="'+handle+'"]');
          if(native){native.click();return}
          window.location.href="/products/"+handle
        });
        bar.appendChild(open);
        var host=item.querySelector(".product-item__image")||item.querySelector(".product-item__bg")||item.querySelector(".pdp-related__card-imgwrap")||item;
        host.appendChild(bar)
      }
    }
  }

  if(isTouch){
    var scanScheduled=false;
    function scanAll(){
      scanScheduled=false;
      document.querySelectorAll(".product-item").forEach(buildBar)
    }
    function scheduleScan(){
      if(!scanScheduled){scanScheduled=true;setTimeout(scanAll,200)}
    }
    if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",scanAll)}else{scanAll()}
    if(window.MutationObserver){
      new MutationObserver(scheduleScan).observe(document.body||document.documentElement,{childList:!0,subtree:!0})
    }
  }else{
    document.addEventListener("mouseover",function(e){
      if(!(!e.target||!e.target.closest)){
        var item=e.target.closest(".product-item");
        item&&buildBar(item)
      }
    },{passive:!0})
  }

  // Watchdog: quick-add dialog stuck in [closing] state blocks the whole page (ghost clicks).
  if(window.MutationObserver){
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        var d=m.target;
        if(d&&d.hasAttribute&&d.hasAttribute("data-quick-add-modal")&&d.hasAttribute("closing")){
          setTimeout(function(){
            if(d.hasAttribute("closing")){
              try{typeof d.close==="function"&&d.close()}catch(err){}
              d.removeAttribute("open");
              d.removeAttribute("closing");
              d.setAttribute("inert","");
              document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:!0}))
            }
          },900)
        }
      })
    }).observe(document.documentElement,{attributes:!0,subtree:!0,attributeFilter:["closing"]})
  }

  // Troca de cor dentro do popup: atualiza o conteudo no lugar (sem fechar/abrir)
  document.addEventListener("click",function(e){
    if(!e.target||!e.target.closest)return;
    var link=e.target.closest(".sibling__link");
    if(!link)return;
    var dlg=link.closest("dialog.product-quick-add, dialog[data-quick-add-modal]");
    if(!dlg)return;
    if(link.classList.contains("sibling__link--current"))return;
    var holder=dlg.querySelector("[data-product-upsell-ajax]");
    var href=link.getAttribute("href")||"";
    var m=href.match(/\/products\/([^\/?#]+)/);
    if(!holder||!m)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(holder._swapping)return;
    holder._swapping=!0;
    holder.style.opacity=".4";
    holder.style.transition="opacity .12s ease";
    fetch("/products/"+m[1]+"?section_id=api-product-upsell",{headers:{Accept:"text/html"}})
      .then(function(r){if(!r.ok)throw 0;return r.text()})
      .then(function(html){
        var doc=(new DOMParser()).parseFromString(html,"text/html");
        var content=doc.querySelector("[data-api-content]");
        if(!content)throw 0;
        holder.innerHTML=content.innerHTML;
        var tip=document.querySelector(".tooltip-default");
        if(tip)tip.classList.remove("is-visible","is-hiding");
        holder.style.opacity="";
        holder._swapping=!1;
      })
      .catch(function(){
        holder.style.opacity="";
        holder._swapping=!1;
        window.location.href=href
      })
  },!0);

  // Rotulo do tamanho: mantem "Selecione" enquanto nada estiver escolhido
  function atipinaSyncSizeLabel(){
    var block=document.querySelector(".pdp-live__variant--size");
    if(!block)return;
    var label=block.querySelector("[data-option-value]");
    if(!label)return;
    var checked=block.querySelector('input[type="radio"]:checked');
    if(!checked){ if(label.textContent.trim()!=="Selecione") label.textContent="Selecione" }
    else if(label.textContent.trim()!==checked.value) label.textContent=checked.value
  }
  document.addEventListener("change",function(e){
    if(e.target&&e.target.closest&&e.target.closest(".pdp-live__variant--size"))setTimeout(atipinaSyncSizeLabel,0)
  },!0);
  document.addEventListener("click",function(){setTimeout(atipinaSyncSizeLabel,60)},!0);
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",function(){setTimeout(atipinaSyncSizeLabel,300);setTimeout(atipinaSyncSizeLabel,1200)})}
  else{setTimeout(atipinaSyncSizeLabel,300);setTimeout(atipinaSyncSizeLabel,1200)}

  // Barra fixa do rodape: some quando o botao principal ou o seletor de tamanho esta na tela
  function atipinaCartBarAutoHide(){
    var bar=document.getElementById("cart-bar");
    if(!bar||!("IntersectionObserver" in window))return;
    var refs=[];
    var cta=document.querySelector("product-component.pdp-live [data-add-to-cart]");
    var sizeBlock=document.querySelector(".pdp-live__variant--size");
    if(cta)refs.push(cta);
    if(sizeBlock)refs.push(sizeBlock);
    if(!refs.length)return;
    var visible=0;
    var seen=new WeakMap();
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var was=seen.get(en.target)||!1;
        var now=en.isIntersecting;
        if(was!==now){seen.set(en.target,now);visible+=now?1:-1}
      });
      if(visible<0)visible=0;
      if(visible>0)bar.classList.add("atipina-bar-hidden");
      else bar.classList.remove("atipina-bar-hidden")
    },{threshold:.2});
    refs.forEach(function(r){io.observe(r)})
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",function(){setTimeout(atipinaCartBarAutoHide,400)})}
  else{setTimeout(atipinaCartBarAutoHide,400)}

  // Carrinho: mostra quanto o cupom vai descontar (o Shopify so aplica no checkout)
  function atipinaMoney(cents){
    var v=(cents/100).toFixed(2).replace(".",","),p=v.split(",");
    p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
    return "R$ "+p.join(",")
  }
  var couponBusy=!1;
  function atipinaCouponEstimate(){
    var holder=document.querySelector("[data-cart-page] .cart__price__holder");
    if(!holder||couponBusy)return;
    var el=holder.querySelector("[data-atipina-coupon-estimate]");
    var active=!1;
    try{active=localStorage.getItem("atipina_newsletter_signed")==="1"||sessionStorage.getItem("atipina_welcome_discount_applied")==="1"}catch(e){}
    if(window.__atipinaCustomerHasOrders===!0)active=!1;
    if(window.__atipinaCartHasDiscount===!0)active=!1;
    if(!active){if(el&&el.parentNode)el.parentNode.removeChild(el);return}
    couponBusy=!0;
    fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}).then(function(cart){
      var total=cart.total_price||0;
      if(!total){if(el&&el.parentNode)el.parentNode.removeChild(el);couponBusy=!1;return}
      var desc=Math.round(total*.1),est=total-desc;
      if(!el){el=document.createElement("div");el.setAttribute("data-atipina-coupon-estimate","");holder.appendChild(el)}
      el.style.cssText="margin:12px 0 0;padding:12px 0 0;border-top:1px solid #ececec;font-family:Poppins,sans-serif;font-size:12.5px;line-height:1.5;color:#1a1d1f";
      var html='<div style="display:flex;justify-content:space-between;gap:12px"><span>Cupom PRIMEIRAAVENTURA (10%)</span><strong style="color:#4b8b3b">- '+atipinaMoney(desc)+'</strong></div>'+
        '<div style="display:flex;justify-content:space-between;gap:12px;margin-top:3px"><span>Total com desconto</span><strong>'+atipinaMoney(est)+'</strong></div>'+
        '<div style="font-size:10.5px;opacity:.6;margin-top:3px">O desconto entra automaticamente no checkout.</div>';
      if(el.innerHTML!==html)el.innerHTML=html;
      couponBusy=!1
    }).catch(function(){couponBusy=!1})
  }
  if(document.querySelector("[data-cart-page]")||/\/cart/.test(location.pathname)){
    setTimeout(atipinaCouponEstimate,600);
    setTimeout(atipinaCouponEstimate,2000);
    document.documentElement.addEventListener("cart:updated",function(){setTimeout(atipinaCouponEstimate,300)});
    document.addEventListener("click",function(e){
      if(e.target&&e.target.closest&&e.target.closest("[data-cart-page]"))setTimeout(atipinaCouponEstimate,900)
    },!0)
  }

  // Home: a foto do capitulo tambem leva para a colecao (nao so o botao)
  function atipinaChapterImagesClickable(){
    document.querySelectorAll(".product-item--featured .grid__heading-holder, .product-item--full .grid__heading-holder").forEach(function(holder){
      if(holder._atipinaLinked)return;
      var link=holder.querySelector(".grid__heading-actions a[href]");
      if(!link)return;
      var href=link.getAttribute("href");
      if(!href)return;
      holder._atipinaLinked=!0;
      var img=holder.querySelector(".grid__heading-image");
      if(img){img.style.cursor="pointer"}
      holder.style.cursor="pointer";
      holder.addEventListener("click",function(e){
        if(e.target&&e.target.closest&&e.target.closest("a,button"))return;
        window.location.href=href
      })
    })
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",function(){setTimeout(atipinaChapterImagesClickable,400);setTimeout(atipinaChapterImagesClickable,1500)})}
  else{setTimeout(atipinaChapterImagesClickable,400);setTimeout(atipinaChapterImagesClickable,1500)}
  if(window.MutationObserver){
    var chapObs=new MutationObserver(function(){clearTimeout(window.__atipinaChapTimer);window.__atipinaChapTimer=setTimeout(atipinaChapterImagesClickable,300)});
    if(document.body)chapObs.observe(document.body,{childList:!0,subtree:!0})
  }

  // Desktop: passar o mouse troca para a SEGUNDA foto (troca simples, sem slider)
  if(isMouse){
    function atipinaBuildHoverImage(item){
      if(item._atipinaHoverImg!==undefined)return item._atipinaHoverImg;
      item._atipinaHoverImg=null;
      var host=item.querySelector(".product-item__image")||item.querySelector(".product-item__bg");
      if(!host)return null;
      var imgs=item.querySelectorAll(".product-item__bg__slide img, [data-hover-slide] img");
      var second=imgs.length>1?imgs[1]:null;
      if(!second)return null;
      var clone=document.createElement("img");
      var src=second.getAttribute("src")||second.currentSrc||"";
      if(!src)return null;
      clone.className="atipina-hover-img";
      clone.setAttribute("aria-hidden","true");
      clone.setAttribute("loading","lazy");
      clone.src=src;
      var ss=second.getAttribute("srcset");
      if(ss)clone.setAttribute("srcset",ss);
      var sizes=second.getAttribute("sizes");
      if(sizes)clone.setAttribute("sizes",sizes);
      host.appendChild(clone);
      item._atipinaHoverImg=clone;
      return clone
    }
    document.addEventListener("mouseover",function(e){
      if(!e.target||!e.target.closest)return;
      var it=e.target.closest(".product-item");
      if(!it)return;
      var img=atipinaBuildHoverImage(it);
      if(img)img.classList.add("is-visible")
    },{passive:!0});
    document.addEventListener("mouseout",function(e){
      if(!e.target||!e.target.closest)return;
      var it=e.target.closest(".product-item");
      if(!it)return;
      if(e.relatedTarget&&it.contains(e.relatedTarget))return;
      var img=it._atipinaHoverImg;
      if(img)img.classList.remove("is-visible")
    },{passive:!0})
  }

  // Mobile: o balao do icone mostra o titulo em cima e o texto embaixo
  function atipinaFeatureTipTitles(){
    document.querySelectorAll(".pdp-live__features--mobile-inline .pdp-live__feature--has-tooltip").forEach(function(f){
      var tip=f.querySelector(".pdp-live__feature-tooltip");
      var label=f.querySelector(".pdp-live__feature-label");
      if(!tip||!label||tip._atipinaTitled)return;
      var txt=(label.textContent||"").trim();
      if(!txt)return;
      tip._atipinaTitled=!0;
      var t=document.createElement("span");
      t.className="pdp-live__feature-tip-title";
      t.textContent=txt;
      tip.insertBefore(t,tip.firstChild)
    })
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",function(){setTimeout(atipinaFeatureTipTitles,500);setTimeout(atipinaFeatureTipTitles,1600)})}
  else{setTimeout(atipinaFeatureTipTitles,500);setTimeout(atipinaFeatureTipTitles,1600)}
  if(window.MutationObserver&&document.body){
    var featObs=new MutationObserver(function(){clearTimeout(window.__atipinaFeatTimer);window.__atipinaFeatTimer=setTimeout(atipinaFeatureTipTitles,300)});
    featObs.observe(document.body,{childList:!0,subtree:!0})
  }

  // Rede de seguranca: o "+" abre o popup em QUALQUER pagina, mesmo se o listener direto falhar
  document.addEventListener("click",function(e){
    if(!e.target||!e.target.closest)return;
    var btn=e.target.closest(".atipina-qa-open");
    if(!btn)return;
    var item=btn.closest(".product-item")||btn.closest("[data-quick-add-holder]")||btn.parentElement;
    if(!item)return;
    var handle=getHandle(item);
    if(!handle)return;
    e.preventDefault();
    e.stopPropagation();
    if(btn._atipinaOpening)return;
    btn._atipinaOpening=!0;
    setTimeout(function(){btn._atipinaOpening=!1},1500);
    var native=item.querySelector("[data-quick-add-btn]")||document.querySelector('[data-quick-add-modal-handle="'+handle+'"]');
    if(native){
      try{native.click()}catch(err){}
      setTimeout(function(){
        if(!document.querySelector("dialog[data-quick-add-modal][open]"))window.location.href="/products/"+handle
      },1800);
      return
    }
    window.location.href="/products/"+handle
  },!0);
})();
